module.exports = __webpack_public_path__ + "static/media/20220626-1.199cfac0.png";